import axios from 'axios'
import {MessageBox} from 'element-ui'
import * as Urls from '../../src/components/url'
const baseUrl = Urls.baseurl + '/api/visitor/service'
const instance = axios.create({
  // baseURL: baseUrl,
  timeout: 10000,
  withCredentials: true
})

export default {
  getCarousel (visitorMd5Code, callback) {
    instance.get(baseUrl + '/navi/questionTypeAndCarousel?visitorMd5Code='+visitorMd5Code, { withCredentials: true }).then(function (resp) {
      callback(resp.data)
    }, function (errorMessage) {
      MessageBox('提示', '网络异常，请稍后再试')
    })
  },
  getHotList (params, callback) {
    axios.get(baseUrl + '/navi/hotIssue?visitorMd5Code='+params.visitorMd5Code + '&page='+ params.page + '&size=' + params.size, { withCredentials: true }).then(function (resp) {
      callback(resp.data)
    }, function (errorMessage) {
      MessageBox('提示', '网络异常，请稍后再试')
    })
  },
  getTypeDetails (params, callback) {
    axios.get(baseUrl + '/navi/questionType?visitorMd5Code='+params.visitorMd5Code + '&id='+ params.id, { withCredentials: true }).then(function (resp) {
      callback(resp.data)
    }, function (errorMessage) {
      MessageBox('提示', '网络异常，请稍后再试')
    })
  },
  getCrouselDetails (params, callback) {
    axios.get(baseUrl + '/navi/carousel?visitorMd5Code='+params.visitorMd5Code + '&id='+ params.id, { withCredentials: true }).then(function (resp) {
      callback(resp.data)
    }, function (errorMessage) {
      MessageBox('提示', '网络异常，请稍后再试')
    })
  },
  // IM
  getEnable (params, callback) {
    axios.get(baseUrl + '/navi/enable?visitorMd5Code='+params.visitorMd5Code, { withCredentials: true }).then(function (resp) {
      callback(resp.data)
    }, function (errorMessage) {
      MessageBox('提示', '网络异常，请稍后再试')
    })
  },
  // 热点
  getHotIssue (params, callback) {
    axios.get(baseUrl + '/navi/getHotIssue?visitorMd5Code='+params.visitorMd5Code + '&id='+ params.id, { withCredentials: true }).then(function (resp) {
      callback(resp.data)
    }, function (errorMessage) {
      MessageBox('提示', '网络异常，请稍后再试')
    })
  },
  /*
  * code
  * talkId
  * type
  * id
  */
  logPoint (params, callback) {
    axios.get(Urls.baseurl + '/api/visitor/log/click', { params }).then(function (resp) {
      callback(resp.body)
    }, function (errorMessage) {
      MessageBox('提示', '网络异常，请稍后再试')
    })
  }
  // ?id=15&visitorMd5Code=6459b13ac009039c9805e79723d9147f
  // getHotIssue (visitorMd5Code, message,callback) {
  //   axios.post(imUrl + '/autoMessage', message, {params: {visitorMd5Code, visitorMd5Code}}).then(function (resp) {
  //     callback(resp.data)
  //   }, function (errorMessage) {
  //     MessageBox('提示', '网络异常，请稍后再试')
  //   })
  // },
}



// WEBPACK FOOTER //
// ./src/api/question.js